/* eslint-disable no-unused-vars */
/* eslint react/prop-types: 0 */
import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  TextField,
  Snackbar,
  TableCell,
  TableFooter,
  TableRow,
} from "@material-ui/core";
import { Box, Stack, styled } from "@mui/material";
import MuiAlert from "@material-ui/lab/Alert";
import {
  APPROVED_STATUS,
  EDIT_STATUS,
  NEW_STATUS,
  PENDING_STATUS,
  INCOMPLETE_STATUS,
  EXCEPTION_STATUS,
  INCOMPLETE_BG_INVALID,
  INCOMPLETE_BG_VALID,
} from "config";
import {
  APPROVED,
  EQUALS,
  IN,
  WORKER_ID,
  IN_TS,
  STATUS,
  SPACE,
} from "config/CONSTANTS";

import Seperator from "components/Seperator";
import { Add } from "@material-ui/icons";
import WeekPicker from "pages/Timesheet/WeekPicker";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import { defaultPaginationOptions, defaultRowsPerPage } from "config/index";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { useHistory, Link } from "react-router-dom";
import { OTHER_TEAM } from "config/CONSTANTS";
import { useDispatch, useSelector } from "react-redux";
import { selectedWeekOnReview } from "../../../../redux/actions/appActions";
import { fetchWorkerDetails } from "services/timesheet";
import { setAllMyWorkers } from "redux/actions/workerActions";
import { ADD_TIMESHEET, CONTRACTOR_TIMESHEET } from "navigation/CONSTANTS";
import LoaderView from "components/LoaderView";
import {
  getWeekNumber,
  updatePunch,
  setPunchHistory,
} from "../../../../services/index";
import { updateTimesheetDocument } from "../../../Timesheet/utils";
import { db, punchesRef } from "services/firebase";
import { properCase, jobTypeITContractor } from "utils";
import { useTranslation } from "react-i18next";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import NoData from "utils/NoData";

const useStyles = makeStyles((theme) => ({
  footerCell: {
    backgroundColor: "#1B75BC",
    borderBottom: "none",
    color: "white",
    fontSize: 14,
    fontWeight: "bolder",
  },
}));
const StyledButton = styled(Button)({
  color:"#1b75bc",
  fontWeight: 600,
  textAlign: "center",
  lineHeight: "25px",
  borderRadius: "5px",
  ':hover':{
    backgroundColor:"#1b75bc",
    color:"#FFFFFF",
  }
});
const ApproveStyledButton = styled(Button)({
  color: "#1b75bc",
  fontWeight: "bold",
  textAlign: "center",
  borderRadius: "5px",
  lineHeight: "20px",
  ":hover": {
    backgroundColor: "#1b75bc",
    color: "#ffffff",
    borderColor: "#1b75bc"
  },
  "&.Mui-disabled": {
    // color: "#FF6E6E",
    color: "rgba(27, 117, 188, 0.5)",
    borderColor: "rgba(27, 117, 188, 0.5)"
  },
});
export default function ManageTimesheetView(props) {
  const dispatch = useDispatch();
  const { appConfig } = useSelector((state) => state);
  const [workers, setWorkers] = React.useState([]);
  const [DisableForApprove, setDisableForApprove] = useState(true);
  const [workersAllData, setWorkersAllData] = React.useState([]);
  const [selectedWorkersForApproval, setSelectedWorkersForApproval] = useState(
    []
  );
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = React.useState(true);
  const [checkboxEnabled, setCheckboxEnabled] = useState(true);
  const {
    allWorkers,
    approveForManager,
    selectedTeam,
    selectedWorkers,
    imtRole,
    isLoading: workersLoading
  } = props;
  const [startDate, setStartDate] = React.useState(
    appConfig.selectedWeekOnReview
      ? moment(appConfig.selectedWeekOnReview.week)
      : new Date()
  );
  const [rowSelection, setRowSelection] = useState({});
  const history = useHistory();
  const { user, isLoading: userLoading } = useSelector(
    (state) => state.user.auth
  );
  const loggedInUser = useSelector((state) => state.user);
  const loggedInSupervisor = loggedInUser.auth.user.workerId;

  const classes = useStyles();

  const weekChangeHandler = (date) => {
    console.log("PunchHeader > WeekPicker value changed===", date);
    var weekStart = moment(date).format();
    console.log("WEEK SELECTION: weekStart: ", weekStart);
    setStartDate(weekStart);
    dispatch(selectedWeekOnReview({ week: weekStart }));
  };

  const [open, setOpen] = useState(false);
  const [approvedStatus, setApprovedStatus] = useState(false);
  //triggered after approved promise is resolved
  function pophandler() {
    console.log("button clicked");
    setOpen(true);
  }
  /* function for alert component used inside snackbar */
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const reportTheme = createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: 10,
        },
      },
      MuiButton: {
        textPrimary: {
          color: "#1B75BC",
        },
      },
      MuiTypography: {
        body2: {
          color: "#1B75BC",
        },
      },
      MuiInputLabel: {
        root: {
          "&$focused": {
            color: "#1B75BC",
          },
        },
      },
      MUIDataTableToolbar: {
        iconActive: {
          color: "#1B75BC",
        },
        icon: {
          "&&:hover": {
            color: "#1B75BC",
          },
        },
      },
      MuiChip: {
        label: {
          color: "#1B75BC",
        },
        deleteIcon: {
          color: "#1B75BC",
        },
      },
      MuiCheckbox: {
        colorPrimary: {
          "&$checked": {
            color: "#1B75BC",
          },
        },
      },
      MuiInput: {
        underline: {
          "&&:after": {
            borderBottom: "2px solid #1B75BC",
          },
        },
      },
    },
  });

  /**
   * function to check if a date in picker is in editable range
   * @return: setState, if editable then set state as true
   */

  const editableCheckbox = (startDate) => {
    if (
      moment(startDate) >=
      moment(new Date()).startOf("week").subtract(2, "weeks")
    )
      setCheckboxEnabled(true);
    else {
      setCheckboxEnabled(false);
    }
  };

  /**
   * function to check if a punch record is selectable
   * @return: {boolean}
   */
  const isRowSelectable = (rowData) => {
    if (rowData) {
      let selectable = [PENDING_STATUS];
      let selectable2 = rowData.jobType
        ? rowData.jobType !== jobTypeITContractor
        : true;
      if (!checkboxEnabled) {
        //console.log("first");
        return false;
      } else {
        if (selectable.indexOf(rowData.status) >= 0 && selectable2) {
          //console.log("second");
          return true;
        } else {
          //console.log("third");
          return false;
        }
      }
    }
  };

  /**
   * function to update the selected punch Id
   * @return: {void}
   */
  const onRowSelectionChange = (currentRows, allRows, row) => {
    console.log("ola onRowSelectionChange: ", currentRows, allRows, row);

    let newSelectedPunches = [];
    row.map((n) => {
      newSelectedPunches.push(workersAllData[n].workerId);
    });
    // setSelectedPunches(newSelectedPunches);
    // setRowsSelected(rowsSelected);
    setSelectedWorkersForApproval(newSelectedPunches);
  };

  /**
   * function to customise the table footer to show totals
   */
  // const customTableBodyFooterRender = (opts) => {
  //   let sunTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[2];
  //   }, 0);

  //   let monTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[3];
  //   }, 0);

  //   let tueTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[4];
  //   }, 0);

  //   let wedTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[5];
  //   }, 0);

  //   let thuTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[6];
  //   }, 0);

  //   let friTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[7];
  //   }, 0);

  //   let satTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[8];
  //   }, 0);

  //   let mealTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[9];
  //   }, 0);

  //   let activityTotal = opts.data.reduce((accu, item) => {
  //     return accu + item.data[10];
  //   }, 0);

  //   let total = opts.data.reduce((accu, item) => {
  //     return accu + item.data[11];
  //   }, 0);

  //   sunTotal = parseFloat(sunTotal).toFixed(2);
  //   monTotal = parseFloat(monTotal).toFixed(2);
  //   tueTotal = parseFloat(tueTotal).toFixed(2);
  //   wedTotal = parseFloat(wedTotal).toFixed(2);
  //   thuTotal = parseFloat(thuTotal).toFixed(2);
  //   friTotal = parseFloat(friTotal).toFixed(2);
  //   satTotal = parseFloat(satTotal).toFixed(2);
  //   mealTotal = parseFloat(mealTotal).toFixed(2);
  //   activityTotal = parseFloat(activityTotal).toFixed(2);
  //   total = parseFloat(total).toFixed(2);

  //   return (
  //     <TableFooter className={classes.footerCell}>
  //       <TableRow>
  //         {opts.selectableRows !== "none" ? (
  //           <TableCell className={classes.footerCell} />
  //         ) : null}
  //         {opts.columns.map((col, index) => {
  //           if (col.display === "true") {
  //             if (col.name === "name") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {t("pgReview.totalHours")}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Sun") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {sunTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Mon") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {monTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Tue") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {tueTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Wed") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {wedTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Thu") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {thuTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Fri") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {friTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "Sat") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {satTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "totalMeal") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {mealTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "totalActivity") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {activityTotal}
  //                 </TableCell>
  //               );
  //             } else if (col.name === "totalHours") {
  //               return (
  //                 <TableCell key={index} className={classes.footerCell}>
  //                   {total}
  //                 </TableCell>
  //               );
  //             } else {
  //               return <TableCell key={index} className={classes.footerCell} />;
  //             }
  //           }
  //           return null;
  //         })}
  //       </TableRow>
  //     </TableFooter>
  //   );
  // };

  // const options = {
  //   filter: true,
  //   download: false,
  //   print: false,
  //   viewColumns: true,
  //   filterType: "multiselect",
  //   setFilterChipProps: (colIndex, colName, data) => {
  //     console.log(colIndex, colName, data);
  //     return {
  //       style: { color: "#1B75BC", border: "1px solid #1B75BC" },
  //       variant: "outlined",
  //       className: "testClass123",
  //     };
  //   },
  //   responsive: "standard",
  //   selectableRows: "multiple",
  //   onRowSelectionChange,
  //   isRowSelectable,
  //   customToolbarSelect: () => { }, //to remove the delete icon from toolbar after selecting row
  //   rowsPerPage: defaultRowsPerPage,
  //   rowsPerPageOptions: defaultPaginationOptions,
  //   customTableBodyFooterRender,
  // };
  useEffect(() => {
    setIsLoading(true);
    let workers;
    editableCheckbox(startDate);
    if (selectedTeam === OTHER_TEAM && approveForManager) {
      if (
        (imtRole && imtRole !== "" && imtRole.toLowerCase() === "supervisor") ||
        (!imtRole && loggedInUser && loggedInUser.auth.user.isApprover)
      ) {
        workers = selectedWorkers;
      } else {
        workers = allWorkers.otherTeam;
      }
    } else {
      workers = allWorkers.myTeam;
    }
    setWorkers(workers);
    console.log("checkbox", checkboxEnabled);
    let tempWorkers = workers ? workers.slice() : [];
    fetchWorkerDetails(workers, startDate).then((res) => {
      tempWorkers = (workers || []).map((worker) => {
        try {
          let temp = res.find(
            (newWorker) => res.indexOf(newWorker) == workers.indexOf(worker)
          );
          let Mon, Tue, Wed, Thu, Fri, Sat, Sun;
          let status;
          let weekTotalHours, meal, activity;
          console.log("this is someTemp ", temp);
          if (temp && temp.value) {
            Mon = temp.value.dayTotals?.Monday?.activityHours;
            Tue = temp.value.dayTotals?.Tuesday?.activityHours;
            Wed = temp.value.dayTotals?.Wednesday?.activityHours;
            Thu = temp.value.dayTotals?.Thursday?.activityHours;
            Fri = temp.value.dayTotals?.Friday?.activityHours;
            Sat = temp.value.dayTotals?.Saturday?.activityHours;
            Sun = temp.value.dayTotals?.Sunday?.activityHours;
            status = temp.value.timesheetStatus;
            meal = temp.value.weekTotalHours?.mealHours;
            activity = temp.value.weekTotalHours?.activityHours;
            weekTotalHours = temp.value.weekTotalHours?.hours;
          }

          if (!Mon) Mon = 0;
          else Mon = parseFloat(Mon.toFixed(2));
          if (!Tue) Tue = 0;
          else Tue = parseFloat(Tue.toFixed(2));
          if (!Wed) Wed = 0;
          else Wed = parseFloat(Wed.toFixed(2));
          if (!Thu) Thu = 0;
          else Thu = parseFloat(Thu.toFixed(2));
          if (!Fri) Fri = 0;
          else Fri = parseFloat(Fri.toFixed(2));
          if (!Sat) Sat = 0;
          else Sat = parseFloat(Sat.toFixed(2));
          if (!Sun) Sun = 0;
          else Sun = parseFloat(Sun.toFixed(2));
          if (!meal) meal = 0;
          else meal = parseFloat(meal.toFixed(2));
          if (!activity) activity = 0;
          else activity = parseFloat(activity.toFixed(2));
          if (!weekTotalHours) weekTotalHours = 0;
          else weekTotalHours = parseFloat(weekTotalHours.toFixed(2));
          return {
            ...worker,
            Mon: Mon,
            Tue: Tue,
            Wed: Wed,
            Thu: Thu,
            Fri: Fri,
            Sat: Sat,
            Sun: Sun,
            status: status,
            totalMeal: meal,
            totalActivity: activity,
            totalHours: weekTotalHours,
          };
        } catch {
          console.log("some error occurred");
        }
      });
      setWorkersAllData(tempWorkers);
      setIsLoading(false);
    });
  }, [
    selectedTeam,
    approvedStatus,
    workers,
    startDate,
    appConfig?.selectedWeekOnReview?.week,
    allWorkers,
    selectedWorkers
  ]);

  let activityTotalRef = useRef();
  let sunTotalRef = useRef();
  let monTotalRef = useRef();
  let tueTotalRef = useRef();
  let wedTotalRef = useRef();
  let thursTotalRef = useRef();
  let friTotalRef = useRef();
  let satTotalRef = useRef();
  let activityIndexArray = [];
  let sunIndexArray = [];
  let monIndexArray = [];
  let tueIndexArray = [];
  let wedIndexArray = [];
  let thursIndexArray = [];
  let friIndexArray = [];
  let satIndexArray = [];
  let activityTotalSum = 0;
  let sunTotal = 0;
  let monTotal = 0;
  let tueTotal = 0;
  let wedTotal = 0;
  let thursTotal = 0;
  let friTotal = 0;
  let satTotal = 0;

  const columns = [
    {
      accessorKey: "name",
      header: properCase(t("other.tlEmployeeName")),
      enableColumnDragging: false,
      Footer: () => (
        <Stack>
          <Box>
            Totals:
          </Box>
        </Stack>
      ),
      filter: true,
      filterType: "dropdown",
      sort: true,
      Cell: ({ renderedCellValue, row }) => {
        let dataIndex = row.index;
        let data = workersAllData[dataIndex];
        console.log("data index", data);
        const link = (
          <Link
            style={{ textDecoration: "none" }}
            to={{
              pathname:
                data.jobType && data.jobType == jobTypeITContractor
                  ? CONTRACTOR_TIMESHEET
                  : "/timesheet",
              state:
                data.jobType && data.jobType == jobTypeITContractor
                  ? {
                      worker: {
                        ...data,
                        name: data?.firstName + SPACE + data?.lastName,
                      },
                    }
                  : { selectedWorker: data, status: data.status },
            }}
          >
            <Typography variant="body2">{renderedCellValue}</Typography>
          </Link>
        );
        return link;
      },
    },
    {
      accessorKey: "workerId",
      header: properCase(t("other.tlWorkerId")),
      filter: true,
      filterType: "dropdown",
      sort: false,
      size: 100,
    },
    // {
    //   name: "isOnLeave",
    //   label: "On Leave",
    //   options: {
    //     filter: true,
    //     sort: false,
    //     customBodyRender: (v) => {
    //       return v ? "Yes" : "No";
    //     },
    //   },
    // },
    // {
    //   name: "workerType",
    //   label: "Worker Type",
    //   options: {
    //     filter: true,
    //     sort: false,
    //   },
    // },

    {
      accessorKey: "Sun",
      header: properCase(t("other.tlSun")),
      size: 50,
      filter: false,
      sort: false,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(sunTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Mon",
      header: properCase(t("other.tlMon")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(monTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Tue",
      header: properCase(t("other.tlTue")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(tueTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Wed",
      header: properCase(t("other.tlWed")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {0 ? 0 : parseFloat(wedTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Thu",
      header: properCase(t("other.tlThu")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(thursTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Fri",
      header: properCase(t("other.tlFri")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(friTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "Sat",
      header: properCase(t("other.tlSat")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(satTotal).toFixed(2)}
          </Box>
        </Stack>
      ),
    },
    {
      accessorKey: "totalActivity",
      header: properCase(t("other.tlActivityTotal")),
      size: 50,
      Footer: () => (
        <Stack>
          <Box className={classes.container}>
            {parseFloat(activityTotalSum).toFixed(2)}
          </Box>
        </Stack>
      ),
      filter: false,
      sort: false,
    },
    // {
    //   accessorKey: "totalHours",
    //   header: properCase(t("other.dscLblTotal")),
    //   size: 50,
    //     filter: false,
    //     sort: false,
    //     display: false,
    // },
    {
      accessorKey: "status",
      header: properCase(t("pgReview.tableHeads.status")), //label={t("other.tlCountry")}
      size: 100,
      enableColumnDragging: false,
      filter: true,
      sort: false,
      //label: properCase(t("pgReview.tableHeads.status")),
      Cell: ({ renderedCellValue, row }) => {
        // customBodyRenderLite: function customRender(dataIndex) {
        let dataIndex = row.index;
        let data = row.original;
        console.log("rowData", data);
        if (data.status?.toLowerCase() === "deleted") {
          delete data.status;
        }
        let pathDetails = {};
        if (data.jobType && data.jobType == jobTypeITContractor) {
          pathDetails = {
            pathname: CONTRACTOR_TIMESHEET,
            state: {
              worker: {
                ...data,
                name: data?.firstName + SPACE + data?.lastName,
              },
            },
          };
        } else {
          pathDetails = {
            pathname: "/timesheet",
            state: {
              selectedWorker: data,
              status: workersAllData[dataIndex].status,
            },
          };
        }
        return data.status?.toLowerCase() == "approved" ? (
          <>
            <Link style={{ textDecoration: "none" }} to={pathDetails}>
              <Typography variant="body2">
                {properCase(t("other.lblApproved"))}
              </Typography>
            </Link>
          </>
        ) : (
          <Link style={{ textDecoration: "none" }} to={pathDetails}>
            <Typography variant="body2">
              {data.status?.toLowerCase() == "inprogress"
                ? properCase(t("other.tlinProgress")) //In progress
                : data.status?.toLowerCase() == "pending"
                ? properCase(t("other.lblPending")) //Pending
                : data.status?.toLowerCase() == "no activity" 
                ? properCase(t("other.txtNoActivity"))
                : properCase(t("other.txtNoActivity"))}
            </Typography>
          </Link>
        );
      },
    },
  ];

  useEffect(() => {
    if (selectedWorkersForApproval.length != 0) {
      setDisableForApprove(false);
    } else {
      setDisableForApprove(true);
    }
  }, [selectedWorkersForApproval]);

  const approvePunchesandTimesheet = async (selectedWeek, selectedWorkers) => {
    table.resetRowSelection();
    return new Promise((resolve, reject) => {
      try {
        for (let i = 0; i < selectedWorkers.length; i++) {
          let eachWorker = selectedWorkers[i];
          let inprogresscountforWorker = 0;
          punchesRef()
            .where(WORKER_ID, EQUALS, eachWorker)
            .where("weekNumber", EQUALS, selectedWeek)
            .where(STATUS, IN, [
              "new",
              "edit",
              "exception",
              "auto completed",
              "auto adjusted",
            ])
            .orderBy(IN_TS)
            .get()
            .then(async (punchDoc) => {
              console.log("punchDoc:", punchDoc);
              const punches = punchDoc.docs;
              let inProgressDays = [];
              for (let i = 0; i < punches.length; i++) {
                const eachPunch = punches[i];
                if (eachPunch.exists) {
                  var punchData = eachPunch.data();
                  if (punchData) {
                    const punchId = eachPunch.id;
                    punchData.status = APPROVED;
                    punchData.actionTS = new Date().toISOString();
                    punchData.actionBy = loggedInSupervisor;
                    if (punchData.outLocalTS != "") {
                      // await updatePunch(punchId, punchData)
                      //   .then(async (data) => {})
                      //   .catch((error) => {
                      //     console.log(error);
                      //   });
                      await setPunchHistory(punchId, eachPunch.data());
                      await eachPunch.ref.update(punchData);
                    } else {
                      inprogresscountforWorker += 1;
                      const dayName = moment(punchData.inLocalTS)
                        .format("dddd")
                        .toString();
                      inProgressDays.push(dayName);
                    }
                  }
                }
              }
              let timesheetStatus = "approved";
              if (inprogresscountforWorker > 0) {
                timesheetStatus = "inProgress";
              }
              let datatoUpdate = {
                timesheetStatus: timesheetStatus,
                inProgressDays: inProgressDays,
                actionBy: loggedInSupervisor,
              };
              await updateTimesheetDocument(
                selectedWeek + "-" + eachWorker,
                datatoUpdate
              )
                .then((result) => {
                  console.log("timesheet approved for:", eachWorker);
                  resolve(true);
                })
                .catch((error) => {
                  console.log("error:", error);
                  reject(error);
                });
            });
        }
      } catch (error) {
        console.error("in services > savePunchestoTimeSheet, Err===", error);
        reject(error);
      }
    });
  };
  const handleApprove = async (selectedWorkers) => {
    //week start sent : appConfig.selectedWeekOnReview.week
    //array of workers : selectedWorkersForApproval
    setDisableForApprove(true); //disable approve button after click
    const selectedWeek = getWeekNumber(appConfig.selectedWeekOnReview.week);
    // const selectedWorkers = selectedWorkersForApproval;

    await approvePunchesandTimesheet(selectedWeek, selectedWorkers)
      .then((result) => {
        console.log("timesheet approved for selected workers");
        setSelectedWorkersForApproval([]);
        pophandler();
        setApprovedStatus((prev)=>!prev);
      })
      .catch((error) => {
        console.log("error:", error);
      });
  };

  const addTimesheet = () => {
    history.push(ADD_TIMESHEET, {
      workers: workers,
    });
  };
  const table = useMaterialReactTable({
    columns,
    data: workersAllData,
    // options: options,
    enableSelectAll: true,
    enablePagination: true,
    enableGrouping: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    localization:{
      noRecordsToDisplay: <NoData/>,
      noResultsFound: <NoData/>
    },
    state:{
      isLoading: isLoading || workersLoading,
      showProgressBars: isLoading || workersLoading
    },
    enableRowSelection: (row) => {
      const rowData = row.original;
      return imtRole === "Support" ? "" : isRowSelectable(rowData)
    },
    enableTableFooter: true,
    enableStickyFooter: true,
    // onRowSelectionChange: onRowSelectionChange,
    muiPaginationProps: {
      rowsPerPageOptions: [10, 25, 50, 100],
      showRowsPerPage: true,
    },
    initialState: {
      density: "compact",
      pagination: {
        pageSize: 50,
      },
    },
    muiTableContainerProps: {
      sx: {
        minHeight: `calc(100vh - 350px)`,
        // he: `calc(100vh - 320px)`,
        maxHeight: `calc(100vh - 350px)`,
        //  maxHeight : "100%"
      },
    },
    muiTableFooterCellProps:{
      sx:{
        backgroundColor: "#1b75bc",
        color:"white",
        fontSize:"1rem",
        padding:"0.6rem"
      }
    },
    muiSkeletonProps:{
      animation: 'wave',
      height: 20
    },
    muiCircularProgressProps:{
      sx:{
        ".MuiCircularProgress-circle":{
          transition: 'none'
        }
      },
      variant: 'determinate'
    },
    renderTopToolbarCustomActions: ({ table }) => {
      table.getSelectedRowModel().flatRows.map((row) => {
        console.log("Selected Row", row);
        setRowSelection(row.id);
      });
      const handleApproveWrap = () => {
        const selectedWorkerId = table
          .getSelectedRowModel()
          .flatRows.map((row) => row.original.workerId);
        handleApprove(selectedWorkerId);
      };
      return (
        <Grid
          container
          style={{
            gap: "20px",
            justifyContent: "space-between",
            alignItems: "flex-end",
            margin: "0 20px",
          }}
        >
          <Typography variant="h6" style={{color: "#58595B"}}> {properCase(t("other.lblManageTimesheets"))}</Typography>
          <Grid item style={{ display: "inline-flex", gap: "30px" }}>
            <span style={{cursor: "not-allowed"}}>
            <ApproveStyledButton
              variant="outlined"
              color="primary"
              onClick={handleApproveWrap}
              disabled={!(table.getIsSomeRowsSelected() || table.getIsAllPageRowsSelected()) || imtRole==="Support"} 
            >
              {properCase(t("pgReview.btnApprove"))}
            </ApproveStyledButton>
            </span>
          </Grid>
        </Grid>
      );
    },
    muiTableBodyRowProps: ({ row }) => {
      let dataIndex = row.index;
      if (workersAllData[dataIndex]) {
        let tempActivityTotal = parseFloat(
          parseFloat(workersAllData[dataIndex].totalActivity) + activityTotalSum
        );

        if (workersAllData[dataIndex].Sun) {
          let tempSunTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Sun) + sunTotal
          );
          if (!sunIndexArray.includes(dataIndex)) {
            sunIndexArray.push(dataIndex);
            setSunActivity(tempSunTotalSum);
          }
        }

        if (workersAllData[dataIndex].Mon) {
          let tempMonTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Mon) + monTotal
          );
          if (!monIndexArray.includes(dataIndex)) {
            monIndexArray.push(dataIndex);
            setMonActivity(tempMonTotalSum);
          }
        }

        if (workersAllData[dataIndex].Tue) {
          let tempTueTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Tue) + tueTotal
          );
          if (!tueIndexArray.includes(dataIndex)) {
            tueIndexArray.push(dataIndex);
            setTueActivity(tempTueTotalSum);
          }
        }
        if (workersAllData[dataIndex].Wed) {
          let tempWedTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Wed) + wedTotal
          );
          if (!wedIndexArray.includes(dataIndex)) {
            wedIndexArray.push(dataIndex);
            setWedActivity(tempWedTotalSum);
          }
        }
        if (workersAllData[dataIndex].Thu) {
          let tempThuTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Thu) + thursTotal
          );
          if (!thursIndexArray.includes(dataIndex)) {
            thursIndexArray.push(dataIndex);
            setThursActivity(tempThuTotalSum);
          }
        }
        if (workersAllData[dataIndex].Fri) {
          let tempFriTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Fri) + friTotal
          );
          if (!sunIndexArray.includes(dataIndex)) {
            friIndexArray.push(dataIndex);
            setFriActivity(tempFriTotalSum);
          }
        }
        if (workersAllData[dataIndex].Sat) {
          let tempSatTotalSum = parseFloat(
            parseFloat(workersAllData[dataIndex].Sat) + satTotal
          );
          if (!satIndexArray.includes(dataIndex)) {
            satIndexArray.push(dataIndex);
            setSatActivity(tempSatTotalSum);
          }
        }
        if (!activityIndexArray.includes(dataIndex)) {
          activityIndexArray.push(dataIndex);
          setTotalActivity(tempActivityTotal);
        }
      }
      return {};
    },
  });

  const setTotalActivity = (val) => {
    activityTotalSum = val;
    if (activityTotalRef.current) {
      activityTotalRef.current.innerText =
        parseFloat(activityTotalSum).toFixed(2);
    }
  };
  const setSunActivity = (val) => {
    sunTotal = val;
    if (sunTotalRef.current) {
      sunTotalRef.current.innerText = parseFloat(sunTotal).toFixed(2);
    }
  };
  const setMonActivity = (val) => {
    monTotal = val;
    if (monTotalRef.current) {
      monTotalRef.current.innerText = parseFloat(monTotal).toFixed(2);
    }
  };
  const setTueActivity = (val) => {
    tueTotal = val;
    if (tueTotalRef.current) {
      tueTotalRef.current.innerText = parseFloat(tueTotal).toFixed(2);
    }
  };
  const setWedActivity = (val) => {
    wedTotal = val;
    if (wedTotalRef.current) {
      wedTotalRef.current.innerText = parseFloat(wedTotal).toFixed(2);
    }
  };
  const setThursActivity = (val) => {
    thursTotal = val;
    if (thursTotalRef.current) {
      thursTotalRef.current.innerText = parseFloat(thursTotal).toFixed(2);
    }
  };
  const setFriActivity = (val) => {
    friTotal = val;
    if (friTotalRef.current) {
      friTotalRef.current.innerText = parseFloat(friTotal).toFixed(2);
    }
  };
  const setSatActivity = (val) => {
    satTotal = val;
    if (satTotalRef.current) {
      satTotalRef.current.innerText = parseFloat(satTotal).toFixed(2);
    }
  };
  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity="success">
          Timesheet is Approved!
        </Alert>
      </Snackbar>
      <Grid container justify="space-between">
        <Grid item>
          <WeekPicker
            size="small"
            variant="outlined"
            weekChangeHandler={weekChangeHandler}
            startDate={startDate}
            renderInput={(params) => (
              <TextField
                {...params}
                label={properCase(t("pgHome.lblReportWeek"))}
                size="small"
                variant="outlined"
              />
            )}
            minDate={moment(new Date()).subtract(3, "months").startOf("month")}
            maxDate={moment(new Date()).add(1, "years")}
          />
        </Grid>
        <Grid item>
          <StyledButton
            variant="outlined"
            color="primary"
            onClick={addTimesheet}
            startIcon={<Add />}
            disabled={imtRole === "Support"}
          >
            {properCase(t("general.lblHours"))}
          </StyledButton>
        </Grid>
      </Grid>
      <Seperator />
      {/* <>
        {isLoading ? (
          <>
            <CircularProgress />
            <Typography variant="body2">
              {properCase(t("pgReview.loadingGoogleUserDetails"))}
            </Typography>
          </>
        ) : ( */}
          <>
            <MuiThemeProvider theme={reportTheme}>
              <MaterialReactTable table={table} />
            </MuiThemeProvider>
            <Box
              mt={2}
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            ></Box>
          </>
        {/* )}
      </> */}
    </>
  );
}
